<template>
  <div>
    <template v-if="items.length">
      <div v-for="(item, index) in items.slice(0, 4)" :key="`${item}-${index}`" class="coupon-id-line">{{ item }}</div>
      <el-button v-if="items.length > 4" type="text" size="mini" @click="$emit('view-all', items)">查看全部（{{ items.length }}）</el-button>
    </template>
    <span v-else>--</span>
  </div>
</template>

<script>
export default { name: 'CouponIdCell', props: { items: { type: Array, default: () => [] } } }
</script>

<style scoped>
.coupon-id-line { line-height: 20px; word-break: break-all; }
</style>
